"use client";

import React from "react";
import styles from "./index.module.css";
import { Button } from "antd";
import { useRouter } from "next/navigation";

const CTA = () => {
  const router = useRouter();
  const titleText = "Ready to Get Started?";
  const subtitleText =
    "Test VeriID in minutes — explore the Playground or start building with the API.";
  const getStartedButtonText = "Get started";
  const playgroundButtonText = "Playground";

  return (
    <section className={styles.cta}>
      <h2>{titleText}</h2>
      <p>{subtitleText}</p>
      <div className={styles.actions}>
        <Button
          type="primary"
          className={styles.getStartedButton}
          onClick={() => router.push("/login")}
        >
          {getStartedButtonText}
        </Button>
        <Button
          type="default"
          className={styles.playgroundButton}
          onClick={() => router.push("/playground")}
        >
          {playgroundButtonText}
        </Button>
      </div>
    </section>
  );
};

export default CTA;
